/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react';
import cx from 'classnames';
import {
  Card,
  Link,
  Text,
} from 'components';
import type { TestGoodsData } from 'types';
import { _t, _t_back } from 'utils';
import styles from './styles.module.scss';

type Props = {
  className?: string,
  value: TestGoodsData,
  targetDetailsPath?: string,
  minCard?: boolean,
};

const PersonalGoodsListLine: FC<Props> = ({
  className,
  value,
  targetDetailsPath,
  minCard = false,
}) => (
  <Card
    key={value.id}
    tag="div"
    className={cx(styles.card, className)}
  >
    <Link
      to={targetDetailsPath ? `${targetDetailsPath}/${value.id}` : `${targetDetailsPath}/`}
      // to={`${targetDetailsPath}/${value.id}`}
      className={styles.linkWrap}
    >
      <div>
        <Text
          size="big"
          bold
          className={styles.title}
        >
          {_t_back(value, 'title')}
        </Text>

        {!minCard && (
          <div className={styles.info}>
            {value.descr}
          </div>
        )}
      </div>

      <div className={styles.cost}>
        {_t('Стоимость')} {value.cost} р/шт
      </div>

      {!minCard && (
        <div className={styles.company}>
          {value.company}
        </div>
      )}
    </Link>
  </Card>
);

export default PersonalGoodsListLine;
